import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ephLogo from "../images/eph_logo.png";
import ReCAPTCHA from "react-google-recaptcha";
import { UrlContext } from "../contexts/UrlContext";

export default function InvalidaConsultant() {
  const navigate = useNavigate();
  const [next, setNext] = useState(false);
  const [loading, setLoading] = useState(false);
  const [linkedinEmail, setLinkedinEmail] = useState("");
  const [validate, setValidate] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const captchaKey = "6Lfvkq8pAAAAAJEgk6BDUbP8Aj67IsHdvQaer5yk";
  const [serverCaptcha, setServerCaptcha] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [ephEmail, setEphEmail] = useState("");
  const [sendCodeLoading, setSendCodeLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [verificationCode, setVerificationCode] = useState("");
  const [codeValidated, setCodeValidated] = useState(false);
  const [showTipLinkedin, setShowTipLinkedin] = useState(false);
  const [showTipEphEmail, setShowTipEphEmail] = useState(false);
  const { API_URL, URI } = useContext(UrlContext);
  const recaptchaRef = React.createRef();
  useEffect(() => {
    if (captchaToken) {
      fetch(`${API_URL}check-captcha-validity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ captchaToken, serverCaptcha }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setCaptchaVerified(true);
          } else {
            setCaptchaVerified(false);
          }
        })
        .catch((err) => console.log(err));
    }
    if (!captchaToken) {
      setCaptchaVerified(false);
    }
  }, [captchaToken]);
  useEffect(() => {
    validateForm();
  }, [linkedinEmail, ephEmail]);

  const createConsultantAccount = (e) => {
    if (validate === "yes" && captchaVerified) {
      setLoading(true);
      fetch(`${API_URL}create-consultant-account`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: linkedinEmail, ephEmail, code: verificationCode }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status == "success") {
            window.open(`${URI}`);
            window.open("about:blank", "_self");
            window.close();
            setLoading(false);
          } else {
            setValidate(
              `${data.message} Get in touch with your EPH contact or Create an Account`
            );

            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (validate == "yes" && !captchaVerified) {
      setValidate("Complete Captcha challenge");
    }
  };

  const sendVerificationCode = async () => {
    if (validate !== "yes" || !captchaVerified) {
      if (!captchaVerified) setValidate("Complete Captcha challenge");
      return;
    }
    setCodeValidated(false);
    setVerificationCode("");
    try {
      setSendCodeLoading(true);
      const res = await fetch(`${API_URL}send-login-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: ephEmail.toLowerCase() }),
      });
      await res.json();
      setCodeSent(true);
      setResendCooldown(60);
      const interval = setInterval(() => {
        setResendCooldown((s) => {
          if (s <= 1) {
            clearInterval(interval);
            return 0;
          }
          return s - 1;
        });
      }, 1000);
    } catch (e) {
      console.log(e);
    } finally {
      setSendCodeLoading(false);
    }
  };

  const validateEnteredCode = () => {
    if (verificationCode.length === 6) {
      setCodeValidated(true);
    } else {
      setCodeValidated(false);
    }
  };

  const validateForm = () => {
    // Validate Linkedin email
    const linkedinValid =
      linkedinEmail &&
      linkedinEmail.includes("@") &&
      linkedinEmail.includes(".");

    // Validate EPH email
    const ephEmailValid =
      ephEmail && ephEmail.includes("@") && ephEmail.includes(".");

    if (!linkedinValid) {
      setValidate("LinkedIn email format should be like user@domain.com");
      return;
    }
    if (!ephEmailValid) {
      setValidate("EPH email format should be like user@domain.com");
      return;
    }
    setValidate("yes");
  };
  return (
    <div className="eph-login-body" style={{ color: "darkgray" }}>
      <div className="eph-login-wrapper fadeInDown">
        <div className="eph-login-formContent">
          <div className="fadeIn first">
            <img className="eph-login-logo" src={ephLogo} alt="EPH Logo" />
            {!next ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                <div>
                  <h5 style={{ fontWeight: "700", color: "#37515e" }}>
                    The linkedin account you used doesn't match with our system{" "}
                  </h5>
                </div>
                <div
                  style={{
                    marginTop: "10px",
                    width: "90%",
                    textAlign: "center",
                  }}
                >
                  <p>
                    {
                      "We did not find any user with that LinkedIn profile. Please register your Linkedin information on the next page or get in touch with your EPH contact."
                    }
                  </p>
                </div>
              </div>
            ) : (
              <div>
                <div
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <form
                    style={{
                      display: "inline-flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%",
                    }}
                    onFocus={() => recaptchaRef.current.execute()}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <input
                        style={{ width: "100%", flex: 1 }}
                        className="my-2"
                        placeholder="Linkedin Account Email"
                        onChange={(e) => {
                          setLinkedinEmail(e.target.value);
                        }}
                      ></input>
                      <span
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                        onMouseEnter={() => setShowTipLinkedin(true)}
                        onMouseLeave={() => setShowTipLinkedin(false)}
                      >
                        <i
                          className="fa-regular fa-circle-question"
                          style={{ color: "#60a5fa", cursor: "help" }}
                          aria-label="The email associated with your LinkedIn account"
                          tabIndex="0"
                        />
                        {showTipLinkedin ? (
                          <span
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              background: "#1f2937",
                              color: "#fff",
                              fontSize: "12px",
                              padding: "6px 8px",
                              borderRadius: "4px",
                              whiteSpace: "nowrap",
                              zIndex: 20,
                              marginTop: "4px",
                            }}
                          >
                            The email associated with your LinkedIn account
                          </span>
                        ) : null}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <input
                        style={{ width: "100%", flex: 1 }}
                        className=" my-2"
                        placeholder="EPH Account Email"
                        type="email"
                        onChange={(e) => {
                          setEphEmail(e.target.value);
                        }}
                      ></input>
                      <span
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                        onMouseEnter={() => setShowTipEphEmail(true)}
                        onMouseLeave={() => setShowTipEphEmail(false)}
                      >
                        <i
                          className="fa-regular fa-circle-question"
                          style={{ color: "#60a5fa", cursor: "help" }}
                          aria-label="The email you used to register on EPH"
                          tabIndex="0"
                        />
                        {showTipEphEmail ? (
                          <span
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              background: "#1f2937",
                              color: "#fff",
                              fontSize: "12px",
                              padding: "6px 8px",
                              borderRadius: "4px",
                              whiteSpace: "nowrap",
                              zIndex: 20,
                              marginTop: "4px",
                            }}
                          >
                            The email you used to register on EPH
                          </span>
                        ) : null}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "4px",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary my-2"
                        style={{
                          backgroundColor: "#37515e",
                          color: "white",
                          width: "100%",
                        }}
                        disabled={
                          validate !== "yes" ||
                          !isChecked ||
                          sendCodeLoading ||
                          resendCooldown > 0
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          sendVerificationCode();
                        }}
                      >
                        {resendCooldown > 0
                          ? `Resend code in ${resendCooldown}s`
                          : "Send verification code"}
                      </button>
                    </div>
                    {codeSent ? (
                      <>
                        <div
                          className="alert alert-light fadeInDown"
                          style={{ width: "100%" }}
                          role="alert"
                        >
                          A 6-digit code was sent to your email. Please check your
                          inbox and SPAM folder.
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginTop: "8px",
                          }}
                        >
                          <input
                            className="form-control"
                            placeholder="Enter 6-digit code"
                            value={verificationCode}
                            onChange={(e) =>
                              setVerificationCode(
                                e.target.value.replace(/\D/g, "").slice(0, 6)
                              )
                            }
                            inputMode="numeric"
                          />
                          <button
                            type="button"
                            className="btn"
                            style={{ backgroundColor: "#9ca3af", color: "white" }}
                            disabled={verificationCode.length !== 6}
                            onClick={(e) => {
                              e.preventDefault();
                              validateEnteredCode();
                            }}
                          >
                            Validate code
                          </button>
                        </div>
                        {codeValidated ? (
                          <div
                            className="alert alert-success"
                            style={{ width: "100%", marginTop: "8px" }}
                            role="alert"
                          >
                            Code validated
                          </div>
                        ) : null}
                      </>
                    ) : null}

                    <ReCAPTCHA
                      ref={recaptchaRef}
                      size="invisible"
                      sitekey={captchaKey}
                      onChange={(value) => {
                        setCaptchaToken(value);
                        setServerCaptcha(
                          "6Lfvkq8pAAAAANBQQAwSyWkRHGYh4D0obJyQrvjo"
                        );
                      }}
                    />
                    <span className="mt-3 mr-1" style={{ width: "100%" }}>
                      <input
                        className="mr-1"
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(!isChecked)}
                      />
                      <span>
                        I agree with EPH{" "}
                        <a
                          style={{ textDecoration: "none", color: "#37515e" }}
                          target="_blank"
                          href="https://www.expertpowerhouse.com/privacy-policy"
                        >
                          Privacy Policy
                        </a>{" "}
                        {" & "}{" "}
                        <a
                          style={{ textDecoration: "none", color: "#37515e" }}
                          target="_blank"
                          href="https://www.expertpowerhouse.com/terms-of-use"
                        >
                          Terms of use
                        </a>
                      </span>
                    </span>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        validateForm();
                        createConsultantAccount(e);
                      }}
                      disabled={
                        validate !== "yes" || !isChecked || loading || verificationCode.length !== 6
                      }
                      className="btn btn-primary m-2 mt-4"
                      style={{
                        backgroundColor: "#37515e",
                        color: "white",
                        width: "100%",
                      }}
                    >
                      Register Linkedin Account
                    </button>
                    {validate && validate !== "yes" ? (
                      <div
                        className="alert alert-danger fadeInDown "
                        style={{ width: "90%" }}
                        role="alert"
                      >
                        {validate}
                      </div>
                    ) : (
                      <div
                        className="alert alert-light"
                        style={{ width: "100%", minHeight: "60px" }}
                        role="alert"
                      ></div>
                    )}
                  </form>
                </div>
              </div>
            )}
            <div className="eph-login-formFooter">
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <button
                  style={{
                    backgroundColor: "white",
                    color: "#37515e",
                    fontWeight: "700",
                    width: "50%",
                  }}
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                  onClick={() => {
                    localStorage.clear();
                    navigate("/");
                  }}
                >
                  Log in with your Email
                </button>
                {!next ? (
                  <button
                    style={{
                      backgroundColor: "#37515e",
                      color: "white",
                      fontWeight: "700",
                      width: "50%",
                    }}
                    type="button"
                    className="btn "
                    onClick={() => {
                      setNext(true);
                    }}
                  >
                    Register Linkedin Account
                  </button>
                ) : (
                  <button
                    style={{
                      backgroundColor: "#37515e",
                      color: "white",
                      fontWeight: "700",
                      width: "50%",
                    }}
                    type="button"
                    className="btn "
                    onClick={() => {
                      window.open(
                        "https://tool.expertpowerhouse.com/new-application"
                      );
                    }}
                  >
                    Create an account
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
